module.exports = __webpack_public_path__ + "static/media/神经网络.6b2a53d7.png";